import { get } from 'lodash';
import { DashboardJson } from '../../../models';
import { CONTAINED_WIDGET_JSON_POINTERS, UNCONTAINED_WIDGET_JSON_POINTERS } from '../constants';
import { WidgetProps } from '../models';

export const getWidgetPropertiesFromTemplate = (widgetTemplate: DashboardJson): WidgetProps => {
  const widget = get(widgetTemplate, 'spec.widget');
  if (widget) {
    return widget as WidgetProps;
  } else {
    // use json pointers to extract widget properties if spec.widget not available
    if (get(widgetTemplate, 'spec.view[1][2]')) {
      // widget has a container
      const widgetPropsFromView = {
        container: {
          name: get(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.CONTAINER.NAME, ''),
          props: get(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.CONTAINER.PROPS, {}),
        },
        component: {
          name: get(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.COMPONENT.NAME, ''),
          props: get(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.COMPONENT.PROPS, {}),
        },
      } as WidgetProps;
      return widgetPropsFromView;
    } else {
      // widget does not have container (e.g. filter)
      const widgetPropsFromView = {
        component: {
          name: get(widgetTemplate, UNCONTAINED_WIDGET_JSON_POINTERS.NAME, ''),
          props: get(widgetTemplate, UNCONTAINED_WIDGET_JSON_POINTERS.PROPS, {}),
        },
      } as WidgetProps;
      return widgetPropsFromView;
    }
  }
};
